import { useRef, useState } from 'react';
import { Container, Paper } from '@mui/material';
//Views
import DashboardPanel from 'Modules/dashboard/views/.components/dashboardPanel';

//Containers
import Preferences from 'Core/containers/Preferences';

const DashboardMain = () => {
    const preferencesRef = useRef();

    //local States
    const [dashboardId, setDashboardId] = useState(null);

    const changeDashboard = (newValues) => {
        newValues && setDashboardId(newValues)
        const oldPreferences = preferencesRef?.current?.getPreferences("Other", "dashboard-view") || {}
        if (!_.isEqual(newValues, oldPreferences)) {
            const currentPreferences = { ...oldPreferences, dashboardId: newValues }
            preferencesRef.current.savePreference("Other", "dashboard-view", currentPreferences)
        }
    }

    return (
        <Container maxWidth={false} className="container-view">
            <Paper elevation={0}>
                <Preferences
                    ref={preferencesRef}
                    preferencesKey="dashboard-view"
                    onInitialPreferences={(preferences) => {
                        if (preferences?.dashboardId != undefined && preferences.dashboardId != null && !dashboardId)
                            setDashboardId(preferences.dashboardId)
                    }}
                >
                    <DashboardPanel changeDashboard={changeDashboard} dashboardId={dashboardId} />
                </Preferences>
            </Paper>
        </Container>
    )
}

export default DashboardMain